let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4vq5I")).then(() => parcelRequire('8KTi9'));